export enum ImageFileType {
  PNG = 'png',
  JPEG = 'jpeg',
}
